import { jsx as s, jsxs as i } from "react/jsx-runtime";
import { Skeleton as p } from "../ui/skeleton.js";
import { cn as r } from "../../lib/utils.js";
import { useState as f } from "react";
import { middlen as v, hexToAscii as b } from "../../utils/cardanoUtils.js";
import y from "../ui/tooltipDialog.js";
import "../../lib.js";
import "../../extend-tailwind-merge-e63b2b56.js";
import "../../index-ca8eb9e1.js";
import "../../config/axios.js";
import "../../axios-ddd885c5.js";
import "../../config/decrypt.js";
import "../../hooks/useScreen.js";
import "../ui/dialog.js";
import "../../index-840f2930.js";
import "../../index-1c873780.js";
import "../../index-c7156e07.js";
import "../../index-563d1ed8.js";
import "../../index-4914f99c.js";
import "../../index-67500cd3.js";
import "../../index-c8f2666b.js";
import "../../_commonjsHelpers-10dfc225.js";
import "../../index-27cadef5.js";
import "../../index-5116e957.js";
import "../ui/tooltip.js";
import "../../index-0ce202b9.js";
import "../../index-bcfeaad9.js";
import "../../index-f7426637.js";
const X = ({
  token: d,
  isVerified: g,
  size: t = 40,
  verifiedSize: l = 15,
  className: o = "dhs-w-8 dhs-h-8 dhs-rounded-full",
  disableTooltip: u = !0,
  verifiedClass: x = void 0
}) => {
  const e = (d == null ? void 0 : d.token_id) || (d == null ? void 0 : d.tokenId) || "", c = `https://storage.googleapis.com/dexhunter-images/tokens/${e}.webp`, [h, n] = f(!1), a = g && /* @__PURE__ */ s(
    "img",
    {
      src: "https://storage.googleapis.com/dexhunter-images/public/verified.svg",
      className: r("dhs-absolute @md/appRoot:dhs-bottom-[-2.5px] @md/appRoot:dhs-right-[-2.5px] dhs-z-2 dhs-bottom-[-1px] dhs-right-[-1px]", x),
      width: l,
      height: l
    }
  );
  return (e === "" || e === "000000000000000000000000000000000000000000000000000000006c6f76656c616365") && d !== void 0 ? /* @__PURE__ */ i(
    "div",
    {
      className: r("dhs-relative dhs-flex dhs-justify-center dhs-items-center dhs-rounded-full", o),
      style: {
        minHeight: t,
        minWidth: t,
        maxHeight: t,
        maxWidth: t
      },
      children: [
        /* @__PURE__ */ s(
          "img",
          {
            src: "https://storage.googleapis.com/dexhunter-images/tokens/cardano.png",
            alt: e,
            width: t,
            height: t,
            className: "dhs-rounded-full"
          }
        ),
        a
      ]
    }
  ) : u ? /* @__PURE__ */ i(
    "div",
    {
      className: r("dhs-relative dhs-flex dhs-justify-center dhs-items-center dhs-rounded-full", o),
      style: {
        minHeight: t,
        minWidth: t,
        maxHeight: t,
        maxWidth: t
      },
      children: [
        !h && /* @__PURE__ */ s(p, { className: r("dhs-absolute dhs-inset-0 dhs-rounded-full") }),
        /* @__PURE__ */ s(
          "img",
          {
            src: c,
            alt: e,
            width: t,
            height: t,
            onLoad: () => n(!0),
            style: {
              display: h ? "block" : "none",
              maxWidth: t,
              maxHeight: t
            },
            className: "dhs-rounded-full",
            onError: (m) => {
              m.target.src = "https://storage.googleapis.com/dexhunter-images/public/unverified.svg";
            }
          }
        ),
        a
      ]
    }
  ) : /* @__PURE__ */ s(
    y,
    {
      activeMobile: !1,
      triggerAsChild: !0,
      trigger: /* @__PURE__ */ i(
        "div",
        {
          className: r("dhs-relative dhs-flex dhs-justify-center dhs-items-center dhs-rounded-full", o),
          style: {
            minHeight: t,
            minWidth: t,
            maxHeight: t,
            maxWidth: t
          },
          children: [
            !h && /* @__PURE__ */ s(p, { className: r("dhs-absolute dhs-inset-0 dhs-rounded-full") }),
            /* @__PURE__ */ s(
              "img",
              {
                src: c,
                alt: e,
                width: t,
                height: t,
                onLoad: () => n(!0),
                style: {
                  display: h ? "block" : "none",
                  maxWidth: t,
                  maxHeight: t
                },
                className: "dhs-rounded-full",
                onError: (m) => {
                  m.target.src = "https://storage.googleapis.com/dexhunter-images/public/unverified.svg";
                }
              }
            ),
            a
          ]
        }
      ),
      content: /* @__PURE__ */ i("div", { className: "dhs-flex dhs-flex-col dhs-gap-1.5 dhs-text-gray-103 dhs-text-sm dhs-p-2", children: [
        /* @__PURE__ */ i("div", { className: "dhs-flex dhs-items-center dhs-gap-8 dhs-justify-between", children: [
          /* @__PURE__ */ s("div", { children: "Token Policy" }),
          /* @__PURE__ */ s(
            "div",
            {
              className: "dhs-break-all dhs-text-accent hover:dhs-opacity-90 dhs-cursor-pointer",
              onClick: () => window.open(`https://cardanoscan.io/token/${e}`),
              children: v(e == null ? void 0 : e.slice(0, 56), 10)
            }
          )
        ] }),
        /* @__PURE__ */ i("div", { className: "dhs-flex dhs-items-center dhs-gap-8 dhs-justify-between", children: [
          /* @__PURE__ */ s("div", { children: "Token Name" }),
          /* @__PURE__ */ s("div", { className: "dhs-text-buttonText", children: (d == null ? void 0 : d.token_ascii) || b(e == null ? void 0 : e.slice(56)) })
        ] })
      ] }),
      contentClass: "dhs-text-mainText"
    }
  );
};
export {
  X as TokenImage,
  X as default
};
